import { Protection } from "@sportal/api";

export interface SBSharedProtection {
  name: Protection;
  categories: string[];
}

export const LOAD_SHARED_PROTECTIONS_SUCCESS =
  "[PROTECTIONS] LOAD_SHARED_PROTECTIONS_SUCCESS";
export const LOAD_SHARED_PROTECTIONS_FAILURE =
  "[PROTECTIONS] LOAD_SHARED_PROTECTIONS_FAILURE";

export type SharedProtectionsSuccessPayload = SBSharedProtection[];

interface LoadSharedProtectionsSuccess {
  type: typeof LOAD_SHARED_PROTECTIONS_SUCCESS;
  payload: SharedProtectionsSuccessPayload;
}

interface LoadSharedProtectionsFailure {
  type: typeof LOAD_SHARED_PROTECTIONS_FAILURE;
  payload: object & { code: number | string };
}

export type ProtectionsActionTypes =
  | LoadSharedProtectionsSuccess
  | LoadSharedProtectionsFailure;
